import { render, staticRenderFns } from "./ResponseType2.vue?vue&type=template&id=2f9a0119&scoped=true&"
import script from "./ResponseType2.vue?vue&type=script&lang=js&"
export * from "./ResponseType2.vue?vue&type=script&lang=js&"
import style0 from "./ResponseType2.vue?vue&type=style&index=0&id=2f9a0119&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9a0119",
  null
  
)

export default component.exports